(function(){
  'use strict';
  function initialize(section){
    if(section.dataset.vjCarouselReady==='true')return;
    var rail=section.querySelector('[data-vj-taste-rail]');
    var cards=rail?Array.prototype.slice.call(rail.querySelectorAll('.vj-taste__card')):[];
    var prev=section.querySelector('[data-vj-taste-prev]');
    var next=section.querySelector('[data-vj-taste-next]');
    var count=section.querySelector('[data-vj-taste-count]');
    var more=section.querySelector('[data-vj-taste-more]');
    if(!rail||!cards.length||!prev||!next||!count||!more)return;
    section.dataset.vjCarouselReady='true';
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var expanded=false;
    var scheduled=false;
    function shown(){return cards.filter(function(card){return !card.hidden;});}
    function step(){
      var gap=parseFloat(getComputedStyle(rail).columnGap)||0;
      return cards[0].getBoundingClientRect().width+gap;
    }
    function update(){
      var n=shown().length;
      var last=Math.max(0,rail.scrollWidth-rail.clientWidth);
      var index=Math.min(n-1,Math.max(0,Math.round(rail.scrollLeft/Math.max(1,step()))));
      count.textContent=String(index+1).padStart(2,'0')+' / '+String(n).padStart(2,'0');
      prev.disabled=rail.scrollLeft<=2;
      next.disabled=rail.scrollLeft>=last-2;
    }
    function refresh(){
      scheduled=false;
      update();
    }
    function onScroll(){
      if(!scheduled){scheduled=true;window.requestAnimationFrame(refresh);}
    }
    function move(direction){
      rail.scrollBy({left:step()*direction,behavior:reduced?'auto':'smooth'});
    }
    prev.addEventListener('click',function(){move(-1);});
    next.addEventListener('click',function(){move(1);});
    rail.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',update,{passive:true});
    rail.addEventListener('keydown',function(event){
      if(event.target!==rail)return;
      if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
        event.preventDefault();
        move(event.key==='ArrowRight'?1:-1);
      }
    });
    more.hidden=cards.length<=3;
    more.addEventListener('click',function(){
      expanded=!expanded;
      cards.forEach(function(card,i){card.hidden=!expanded&&i>=3;});
      more.setAttribute('aria-expanded',String(expanded));
      more.innerHTML=expanded?'SHOW FEWER DISHES <span aria-hidden="true">↑</span>':'VIEW MORE DISHES <span aria-hidden="true">→</span>';
      if(expanded){
        rail.scrollTo({left:step()*3,behavior:reduced?'auto':'smooth'});
      }else{
        rail.scrollTo({left:0,behavior:reduced?'auto':'smooth'});
      }
      window.requestAnimationFrame(update);
    });
    cards.forEach(function(card,i){card.hidden=i>=3;});
    window.requestAnimationFrame(update);
  }
  document.querySelectorAll('[data-vj-carousel]').forEach(initialize);
  document.addEventListener('shopify:section:load',function(event){
    if(event.target.matches('[data-vj-carousel]'))initialize(event.target);
    event.target.querySelectorAll('[data-vj-carousel]').forEach(initialize);
  });
})();
